<div class="labelHeader" *ngIf="label">{{label}}</div>
<div #sliderContainer (click)="onClick()"
     (keydown)='onKeydown($event)'
     [class.hideSliderPointer]="hideSliderPointer"
     [class.hideValueBubble]="hideValueBubble"
     [class.disabled]="ngDisabled | acFunc : validatorsService.isFieldDisabled : acInputContainerComponent?.isDisabled : acFormComponent?.isDisabled"
     class="slider-container">
    <ngx-slider *ngIf="showSlider"
                [value]="acModel"
                (valueChange)="onChange($event)"
                [options]="_options">
    </ngx-slider>
</div>
